import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import { Toaster } from 'react-hot-toast';

import {
  ThirdwebProvider,
  metamaskWallet,
  coinbaseWallet,
  walletConnect
} from "@thirdweb-dev/react";
import { Binance, Ethereum, Polygon, Avalanche } from "@thirdweb-dev/chains";

if (!!window.ethereum) {
    window.ethereum.autoRefreshOnNetworkChange = false
}

ReactDOM.render(
  <React.StrictMode>
      <BrowserRouter>
        <ThirdwebProvider 
          supportedWallets={[
            metamaskWallet(),
            coinbaseWallet(),
            walletConnect({
              projectId: "4cf3f0166aeb1dc2245d5cf88287a4d2"
            })
          ]}
          activeChain={Binance.slug}
          supportedChains={[Binance, Ethereum, Polygon, Avalanche]}
          >
          <App />
          <Toaster />
        </ThirdwebProvider>
      </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)